
import { useNavigate } from 'react-router-dom';
import { serviceCategories } from '../../../mocks/servicesData';

const highlights = serviceCategories.map((s) => ({
  id: s.id,
  title: s.title,
  icon: s.icon,
  tagline: s.tagline,
  description: s.description,
}));

export default function ContactServices() {
  const navigate = useNavigate();

  return (
    <section className="py-20 px-6 lg:px-12 bg-stone-50">
      <div className="max-w-6xl mx-auto">
        {/* Heading */}
        <div className="text-center mb-14">
          <p className="text-amber-600 text-xs tracking-[0.35em] uppercase font-medium mb-2">
            What We Offer
          </p>
          <h2
            className="text-4xl font-light text-stone-800 mb-3"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Our Services
          </h2>
          <div className="w-16 h-px bg-gradient-to-r from-transparent via-amber-400 to-transparent mx-auto mb-5" />
          <p className="text-stone-500 text-sm max-w-xl mx-auto leading-relaxed">
            From intimate celebrations to full venue transformations — here's how House of FMR can bring your vision to life.
          </p>
        </div>

        {/* Service Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-14">
          {highlights.map((service, i) => (
            <div
              key={service.id}
              className="group bg-white rounded-xl p-6 shadow-sm border border-stone-100 hover:shadow-md hover:border-amber-200 transition-all duration-300"
              style={{ animationDelay: `${i * 80}ms` }}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-amber-50 border border-amber-100 mb-4 group-hover:bg-amber-100 transition-colors duration-300">
                <i className={`${service.icon} text-amber-500 text-xl`}></i>
              </div>
              <h3
                className="text-stone-800 font-semibold text-base mb-1"
                style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '1.1rem' }}
              >
                {service.title}
              </h3>
              <p className="text-amber-600 text-xs tracking-wide uppercase mb-3 font-medium">
                {service.tagline}
              </p>
              <p className="text-stone-500 text-xs leading-relaxed line-clamp-3">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        {/* Process strip */}
        <div className="bg-white rounded-2xl border border-stone-100 shadow-sm px-8 py-10">
          <p className="text-center text-amber-600 text-xs tracking-[0.3em] uppercase font-medium mb-8">
            How It Works
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { step: '01', icon: 'ri-phone-line', title: 'Initial Consultation', desc: 'Tell us about your event — vision, guest count, and budget.' },
              { step: '02', icon: 'ri-file-list-3-line', title: 'Custom Proposal', desc: 'Receive a tailored proposal with styling ideas and pricing within 48 hrs.' },
              { step: '03', icon: 'ri-palette-line', title: 'Planning & Styling', desc: 'We handle decor sourcing, equipment hire, and all the details.' },
              { step: '04', icon: 'ri-sparkling-2-line', title: 'Event Day Setup', desc: 'We arrive early, set up everything perfectly, and you enjoy the day.' },
            ].map((item) => (
              <div key={item.step} className="flex flex-col items-center text-center">
                <div className="relative mb-4">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-amber-50 border-2 border-amber-200">
                    <i className={`${item.icon} text-amber-500 text-xl`}></i>
                  </div>
                  <span className="absolute -top-1 -right-1 w-5 h-5 flex items-center justify-center rounded-full bg-amber-500 text-white text-[10px] font-bold">
                    {item.step}
                  </span>
                </div>
                <h4 className="text-stone-800 font-semibold text-sm mb-1">{item.title}</h4>
                <p className="text-stone-500 text-xs leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-stone-500 text-sm mb-5">
            Want to explore our full service offering before getting in touch?
          </p>
          <button
            onClick={() => navigate('/services')}
            className="inline-flex items-center gap-2 px-8 py-3 border border-amber-400 text-amber-600 hover:bg-amber-500 hover:text-white text-sm font-semibold tracking-widest uppercase rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-arrow-right-line"></i>
            View Full Services
          </button>
        </div>
      </div>
    </section>
  );
}
